import {Component, ElementRef, EventEmitter, Input, Output} from '@angular/core';
import {PrintSingleDocument} from '../../shared/models/print';
import {SyncService} from '../../shared/services/sync.service';
import {AbstractPrintComponent} from '../abstract-print/abstract-print.component';

@Component({
  selector: 'app-print-single-document',
  templateUrl: './print-single-document.component.html',
  styleUrl: './print-single-document.component.scss'
})
export class PrintSingleDocumentComponent extends AbstractPrintComponent {
  @Input() data: PrintSingleDocument;
  @Output() init: EventEmitter<any> = new EventEmitter<any>();

  constructor(public sync: SyncService, elRef: ElementRef) {
    super(elRef);
  }
}
